import axios from 'axios';
import store from '@/store';
import { Message } from 'element-ui';

// create an axios instance
const service = axios.create({
  baseURL: '/', // url = base url + request url
  // timeout: 5000 // 超时
});

// 提取路由path
function extractRoutePath(routerData) {
  let routePath = routerData.path;
  if (!routerData.matched || routerData.matched.length === 0) {
    return routePath;
  }
  const matchedItem = routerData.matched[routerData.matched.length - 1];
  if (!matchedItem || !matchedItem.path) {
    return routePath;
  }
  const matchedPath = matchedItem.path;
  let pubPathItems = [];
  for (let i = 0; i < routePath.length && i < matchedPath.length; i++) {
    if (routePath[i] !== matchedPath[i]) {
      break;
    }
    pubPathItems.push(routePath[i]);
  }
  if (pubPathItems.length === 0) {
    return routePath;
  }
  if (pubPathItems[pubPathItems.length - 1] === '/' && pubPathItems.length >= 2) {
    pubPathItems = pubPathItems.slice(0, pubPathItems.length - 1);
  }
  routePath = pubPathItems.join('');
  return routePath;
}

// 提取请求方法名
function extractMethodName(postData) {
  let methodName = '';
  try {
    if (!postData) {
      return '';
    }
    let jsonData = {};
    if (typeof postData === 'string') {
      jsonData = JSON.parse(postData);
    } else {
      jsonData = postData;
    }
    if (!jsonData.Action || !jsonData.Method) {
      return '';
    }
    const action = jsonData.Action;
    const method = jsonData.Method;
    if ((action === 'QueryData' || action === 'OperateData') && jsonData.SchemaId) {
      methodName = `${action}-${method}[SchemaId=${jsonData.SchemaId}]`;
    } else {
      methodName = `${action}-${method}`;
    }
  } catch (e) {
    return '';
  }
  return methodName;
}

// 请求拦截器 request interceptor
service.interceptors.request.use(
  (request) => {
    // 配置识别为ajax接口
    request.headers['X-Requested-With'] = 'XMLHttpRequest';
    const routerData = store.state.setting.RouterData;
    if (routerData && routerData.path) {
      const routePath = encodeURIComponent(extractRoutePath(routerData));
      request.headers['route-path'] = routePath;
    }
    if (routerData.meta && routerData.meta.title) {
      const routePathName = btoa(unescape(encodeURIComponent(routerData.meta.title)));
      request.headers['route-path-name'] = routePathName;
    }
    if (request.data && request.url && request.url.indexOf('?') === -1) {
      const methodName = extractMethodName(request.data);
      request.url = `${request.url}?method=${methodName}`;
    }
    request.headers.AuthToken = encodeURIComponent(localStorage.getItem('AuthToken') || '');
    request.headers.UserId = encodeURIComponent(localStorage.getItem('UserId') || '');
    request.headers.hyhdinfo = encodeURIComponent(localStorage.getItem('UserId') || '');

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// 回复拦截器 response interceptor
service.interceptors.response.use(
  (response) => {
    if (response.data.status === 401) {
      localStorage.clear();
      if (location.pathname == '/operateManage/business/agency') {
        location.href = '/poManage/formal/list';
      } else {
        const url = window.parent.location.href;
        localStorage.setItem('nowUrl', url);
        location.href = `${location.origin}/translate/business/login?from=${location.href}`;
      }
    }
    return response;
  },
  (error) => {
    const status = error && error.response && error.response.status;
    const detail = error && error.response && error.response.data && (error.response.data.detail || error.response.data.msg);

    // 401/403 属于“HTTP 层失败”，会走这里；之前只在 response success 分支判断，导致无法统一提示
    if (status === 401) {
      localStorage.clear();
      if (location.pathname == '/operateManage/business/agency') {
        location.href = '/poManage/formal/list';
      } else {
        const url = window.parent.location.href;
        localStorage.setItem('nowUrl', url);
        location.href = `${location.origin}/translate/business/login?from=${location.href}`;
      }
      return Promise.resolve({ data: { status: 401, msg: detail || '未登录或认证失败', data: null } });
    }

    if (status === 403) {
      Message.warning(detail || '权限不足');
      location.href = '/403';
      return Promise.resolve({ data: { status: 403, msg: detail || '权限不足', data: null } });
    }

    return Promise.reject(error);
  }
);

export default service;